import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_2td2gj3xv9: FaireCollectionEntity = {
  token: "pbc_2td2gj3xv9",
  type: "collection",
  name: "Mother's Day",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d7dfb0219d1a798da1cd367f6125a29c7e54c03d93e2c0afc8669824b2666ec4.jpeg",
  itemCount: 12,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:24.358Z",
    importedBy: "entity-db-import-collections",
  },
};
